var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-info" },
      [
        _c(
          "el-form",
          { ref: "voucherInfo", attrs: { model: _vm.devcInfoForm } },
          [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("信息单")])
            ]),
            _vm._v(" "),
            _vm.isAdd
              ? _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("信息单模版")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pos-rel",
                        staticStyle: { width: "470px" }
                      },
                      [
                        _c("el-input", {
                          staticClass: "bottom-line width-1-5x",
                          attrs: { disabled: true },
                          model: {
                            value: _vm.tplName,
                            callback: function($$v) {
                              _vm.tplName = $$v
                            },
                            expression: "tplName"
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          attrs: { title: "选择信息单模版" },
                          on: {
                            click: function($event) {
                              _vm.tplDlg()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "name",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "415px" },
                        attrs: { type: "text", placeholder: "请输入名称" },
                        model: {
                          value: _vm.devcInfoForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.devcInfoForm, "name", $$v)
                          },
                          expression: "devcInfoForm.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content-caption dashed",
                staticStyle: { "margin-top": "50px" }
              },
              [_c("span", [_vm._v("信息单项")])]
            ),
            _vm._v(" "),
            _c("table", { staticClass: "custom-tbl error-prompt" }, [
              _c("thead", { staticClass: "head" }, [
                _c("tr", { staticClass: "row" }, [
                  _c(
                    "th",
                    { staticClass: "required", attrs: { width: "500" } },
                    [_vm._v("标签")]
                  ),
                  _vm._v(" "),
                  _c("th", { staticClass: "required" }, [_vm._v("内容")]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "120" } }, [_vm._v("操作")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                { staticClass: "body" },
                _vm._l(_vm.devcInfoForm.itemList, function(item, index) {
                  return _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "itemList." + index + ".label",
                              rules: {
                                required: true,
                                type: "string",
                                message: "标签不能为空",
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "text" },
                              model: {
                                value: item.label,
                                callback: function($$v) {
                                  _vm.$set(item, "label", $$v)
                                },
                                expression: "item.label"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "itemList." + index + ".value",
                              rules: {
                                required: true,
                                type: "string",
                                message: "内容不能为空",
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: item.value,
                                callback: function($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-arrow-top swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.moveUpItem(index, true)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-arrow-bottom swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.moveUpItem(index, false)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.removeItem(index)
                            }
                          }
                        },
                        [_vm._v("移除")]
                      )
                    ])
                  ])
                })
              ),
              _vm._v(" "),
              _c("tfoot", { staticClass: "foot" }, [
                _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        border: "1px solid #dfe6ec",
                        "text-align": "center"
                      },
                      attrs: { colspan: "3" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.addItem()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon iconfont icon-jiahao mr5"
                          }),
                          _vm._v(" "),
                          _c("a", [_vm._v("添加")])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d415a97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d415a97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DevcInfoFormSave.vue
// module id = 3081
// module chunks = 0